import { Button, FormInstance, Row } from "antd";
import { useMemo } from "react";
import { usePermissions } from "../../../lib/hooks/usePermissions";
import { ScheduleEmail } from "../../ScheduleEmail";
import dayjs from "dayjs";

type FooterProps = {
  form: FormInstance;
  data: any;
  mailingType: 1 | 2 | 3;
  isSaving: boolean;
  canceled: boolean;
  close: () => void;
  onSave: () => void;
  reschedule: (values: any) => void;
  resend: () => void;
};

export const Footer = ({
  form,
  data,
  isSaving,
  close,
  mailingType,
  canceled,
  onSave,
  reschedule,
  resend
}: FooterProps) => {
  const { hasAccess } = usePermissions();

  const showSendBtn: boolean = useMemo(() => {
    if (!data) {
      return false;
    }

    if (canceled) {
      return true;
    }
    if (mailingType === 1 && data.status) {
      return [2, 3, 10].includes(data.status) ? false : hasAccess("MailingEmails", "SaveAndSend");
    }
    return false;
  }, [hasAccess, mailingType, data, canceled]);

  const showResend: boolean = useMemo(() => (data ? data.status === 2 : false), [data]);

  const initialData = useMemo(() => {
    if (data) {
      const scheduledDate = dayjs(data.scheduledDate).hour(8);

      const year = scheduledDate.get("year") + 5;

      return {
        frequencyType: data.frequencyType,
        scheduledDate: scheduledDate,
        endConditionType: data.endConditionType || 3,
        endDate: data.endDate ? dayjs(data.endDate) : scheduledDate.year(year),
        maxOccurrences: data.maxOccurrences || 5
      };
    }

    return null;
  }, [data]);

  return (
    <Row className="w-100 justify-end pa-4">
      {showSendBtn && (
        <Button type="primary" shape="round" className="ml-2" disabled={isSaving} loading={isSaving} onClick={onSave}>
          Send
        </Button>
      )}
      {canceled && (
        <ScheduleEmail
          form={form}
          initialData={initialData}
          onSchedule={reschedule}
          isLoading={isSaving}
          disabled={isSaving}
        />
      )}
      {showResend && (
        <Button shape="round" disabled={isSaving} loading={isSaving} onClick={resend}>
          Resend
        </Button>
      )}
      <Button
        type={showSendBtn ? "default" : "primary"}
        shape="round"
        className="ml-2"
        onClick={close}
        disabled={isSaving}
      >
        {showSendBtn ? "Cancel" : "Close"}
      </Button>
    </Row>
  );
};
